/**
 * Created by Administrator on 2017/7/2.
 */
export const SHOWCAROUSEL = 'ShowCarousel';


// WEBPACK FOOTER //
// ./src/Component/BlogList/actionTypes.js